import React, { Component } from 'react';
import NumericInput from 'react-numeric-input';

const noop = () => { };
class HoursMinutesPicker extends Component {
    handleChangeHours = (value) => {
        this.props.handleChange(value, this.props.nbMinutes, this.props.name);
    }
    handleChangeMinutes = (value) => {
        this.props.handleChange(this.props.nbHours, value, this.props.name);
    }

    render() {
        const { classes, label, style, hourFormat, minuteFormat, minuteMax = 59, minuteStep = 0 } = this.props;
        return (
            <div className={classes.hoursMinutesContainer} >
                {label ? <div className={classes.classLabel}>{label}</div> : ''}
                <NumericInput
                    min={0} max={24} step={1} precision={0}
                    value={this.props.nbHours}
                    strict={true}
                    onChange={(value) => this.handleChangeHours(value)}
                    style={style ? style : { input: { width: '42px' } }}
                    format={hourFormat}
                />
                <NumericInput
                    min={0} max={minuteMax} step={minuteStep} precision={0}
                    value={this.props.nbMinutes}
                    strict={true}
                    onChange={(value) => this.handleChangeMinutes(value)}
                    style={style ? style : { input: { width: '42px' } }}
                    format={minuteFormat}
                />
            </div>
        )
    };
}

/**
 * @param {{
 *  value: number;
 *  format: (value: number) => string;
 *  onChange: (value: number) => void;
 *  style?: React.CSSProperties;
 *  label?: string;
 *  classes?: *;
 *  step?: number;
 *  min?: number;
 *  max?: number;
 *  wit?: number;
 *  disabled?: boolean;
 * }} param0
 */
export const NumericPicker = ({
    value,
    format = (num) => num,
    min = 0,
    step = 1,
    style = {},
    classes = {},
    onChange = noop,
    wait = 300,
    ...props
}) => (
    <div style={{ display: 'inline-block' }} className={classes?.container}>
        <NumericInput
            {...props}
            min={min}
            max={999}
            step={step}
            value={value}
            strict={true}
            onChange={onChange}
            style={style ? style : { input: { width: '42px' } }}
            format={format}
        />
    </div>
);

export default HoursMinutesPicker;
